const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-promo-banner'] = {
        c: () => require('partner/modules/cus-promo-banner/cus-promo-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-promo-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-promo-banner'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };